import * as React from "react";
import type { SVGProps } from "react";
const SvgQuickbooksSynced = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <rect width={18} height={18} fill="#259316" rx={4} />
    <path
      fill="#fff"
      d="M3.33 9.001c0 .829.322 1.623.894 2.209.573.585 1.35.915 2.16.915h.435v-1.16h-.436a1.9 1.9 0 0 1-.739-.146 1.9 1.9 0 0 1-.628-.424 2.003 2.003 0 0 1 0-2.788c.18-.182.394-.326.628-.424.235-.098.486-.147.74-.145H7.43v6.068c0 .308.12.603.332.82.213.218.501.34.802.34V5.878h-2.18c-.402 0-.799.08-1.17.238a3.1 3.1 0 0 0-.99.677 3.1 3.1 0 0 0-.662 1.013 3.2 3.2 0 0 0-.232 1.195m8.287-3.123h-.436v1.16h.436c.505.006.988.215 1.343.583.355.367.554.863.554 1.38s-.199 1.013-.554 1.38a1.9 1.9 0 0 1-1.343.583H10.57V4.896a1.18 1.18 0 0 0-.332-.82 1.13 1.13 0 0 0-.802-.34v8.389h2.181c.81 0 1.586-.33 2.159-.915A3.16 3.16 0 0 0 14.67 9a3.16 3.16 0 0 0-.894-2.208 3.02 3.02 0 0 0-2.159-.915"
    />
  </svg>
);
export default SvgQuickbooksSynced;
